/** Replace `{{key}}` placeholders in i18n strings. */
export function interpolateI18n(template: string, vars: Record<string, string>): string {
  return Object.entries(vars).reduce(
    (out, [key, value]) => out.replace(new RegExp(`\\{\\{${key}\\}\\}`, 'g'), value),
    template
  );
}
